import { useDispatch } from 'react-redux';

import { configureStore } from '@reduxjs/toolkit';

import { analyticsMiddleware } from './analyticsMiddleware';
import { appReducer } from './slices';

export const store = configureStore({
  reducer: {
    app: appReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(analyticsMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
